<template>
  <a-row :gutter="16">
    <a-col :xs="{ span: 24 }" :lg="{ span: col.left }">
      <a-config-provider :locale="getLocalConfigProvider()">
        <a-list bordered item-layout="horizontal" :data-source="data_col_left">
          <a-list-item slot="renderItem" slot-scope="item, index"
            :class="item.title.includes('PBK Value') || item.title.includes('Previous SPT') ? 'bg_yellow' : (item.value ? (item.value < 0 ? 'bg_green' : 'bg_red') : '')">
            <a-list-item-meta>
              <span slot="description" v-if="data_col_left.length - 1 != index">
                {{ item.description }}
              </span>
              <span slot="description" v-else style="font-size: medium;">
                {{ item.description }}
                <br/>
                <br/>
                <span :style="item.value < 0 ? 'color:green' : 'color:red'"
                v-if="item.description!=''"
                >
                  ({{ item.value < 0 ? 'Overpayment' : 'Insufficient Payment' }}) 
                </span>
                <sup >
                  
                </sup>
              </span>
              <span v-if="data_col_left.length - 1 != index" slot="title">
                {{ item.title }}
                <a v-if="item.title.includes('PBK Value')" @click="viewtransPBK">(View Detil)</a>
              </span>
              <h3 v-else slot="title">
                {{ item.title }}
              </h3>
              <a-avatar v-if="(data_col_left.length - 1 != index) 
                && !item.title.includes('Previous SPT')
                && !item.title.includes('Total')" slot="avatar" style="backgroundColor:#87d068" icon="tag"
                size="small" />
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </a-config-provider>
      <a-form-item label="Note" v-if="data_col_left[data_col_left.length-1].value < 0">
        <a-textarea placeholder="Write the note here ... " :rows="3" v-model="note" />
      </a-form-item>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: col.right }">
      <div class="container-headertable">
        <div class="m-display-flex space-between align-middle">
          <span>List Tax Details</span>
          <a-button
            v-if="position_status == 'create' && collectData.status_besar != null && collectData.status_besar != 'Release'"
            @click="handleToEdit()" size="small" type="danger">
            <span>Edit</span>
          </a-button>
          <a-button-group
            v-if="position_status != 'create' && collectData.status_besar != null && collectData.status_besar != 'Release'">
            <a-button @click="handleToSave()" size="small" type="primary" :loading="loading.savedtl">Save</a-button>
            <a-button @click="handleToEdit()" size="small" type="danger" :disabled="loading.savedtl">Cancel</a-button>
          </a-button-group>
        </div>
      </div>
      <a-config-provider :locale="getLocalConfigProvider()">
        <a-table v-if="position_status == 'create'" bordered size="small" id="tbl_dtl"
          :rowKey="(record, index) => { return index; }" :columns="columns.create" :dataSource="data_source.trans"
          :pagination="pagination" :scroll="{ x: 835 }">
          <template slot="nomor" slot-scope="text, data, index">
            <span>{{
              (pagination.page - 1) * pagination.pageSize + index + 1
            }}</span>
          </template>
          <template slot="notrans" slot-scope="text, data">
            <span v-if="data.type == 'tax_manual'">{{
              data.no_trans
            }}</span>
            <!-- <a v-else-if="data.type == 'tax_verification'" 
                @click="handlelinkTaxVerivication(data)">{{ data.no_trans }}</a>
              <a v-else @click="handlelinkNo(data)">{{ data.no_trans }}</a> -->
            <a @click="handlelinkNo(data)">{{ data.no_trans }}</a>
            <br />
            <b><small>{{ data.type_label }}</small></b>
          </template>
          <template slot="tax_type_date" slot-scope="text, data">
            <b>{{ data.tax_type_label }}</b> /<br />
            <span>{{
              data.tax_date
              ? moment(data.tax_date).format(getDefaultDateFormat)
              : "-"
            }}</span>

          </template>
          <template slot="dpptax" slot-scope="text, data">
            <div style="width:100%">
              <span style="float:center">{{
                formatCurrency("IDR", data.value_dpp)
              }} /</span><br />
              <span style="float:center">{{
                formatCurrency("IDR", data.value)
              }}</span>
            </div>
          </template>
          <template slot="document_tax" slot-scope="text, data">
            <div style="width:100%;text-align:center">
              {{ data.document_sts == "Document Not Complete" ? "Not Complete" : "Complete" }}
              <a-tooltip placement="bottomRight" title="View Document">
                <a-button icon="file" size="small" type="link" v-if="!(
                    data.document_tax &&
                    data.document_tax == 'No File Uploaded'
                  )
                  " @click="handleviewAttacment(data)"></a-button>
                <a-button v-else :disabled="true" size="small" type="link" icon="file"></a-button>
              </a-tooltip>
            </div>
          </template>
        </a-table>
        <a-table v-else bordered size="small" id="tbl_dtl" :rowKey="(record, index) => { return index; }"
          :columns="columns.edit" :dataSource="data_source.ori" :pagination="pagination" :scroll="{ x: 835 }">
          <template slot="title">
            <a-input-search v-model="search" @change="searching" placeholder="Quick Search" />
          </template>
          <template slot="nomor" slot-scope="text, data, index">
            <span>{{
              (pagination.page - 1) * pagination.pageSize + index + 1
            }}</span>
          </template>
          <template slot="trans_dt" slot-scope="text, data">
            <span>{{
              data.trans_dt
              ? moment(data.trans_dt).format(getDefaultDateFormat)
              : "-"
            }}</span><br />
            <span>{{ data.tlc }}</span>
          </template>
          <template slot="invoicedate" slot-scope="text, data">
            <span>{{
              data.invoice_dt
              ? moment(data.invoice_dt).format(getDefaultDateFormat)
              : "-"
            }}</span>
          </template>
          <template slot="no_trans" slot-scope="text, data">
            <span v-if="data.type == 'tax_manual'">{{
              data.no_trans
            }}</span>
            <!-- <a v-else-if="data.type == 'tax_verification'" 
                  @click="handlelinkTaxVerivication(data)">{{ data.no_trans }}</a>
                <a v-else @click="handlelinkNo(data)">{{ data.no_trans }}</a> -->
            <a @click="handlelinkNo(data)">{{ data.no_trans }}</a>
            <br />
            <b><small>{{ data.type_label }}</small></b>
          </template>
          <template slot="tax_dt" slot-scope="text, data">
            <b>{{ data.tax_type_label }}</b> /<br />
            <span>{{
              data.tax_date
              ? moment(data.tax_date).format(getDefaultDateFormat)
              : "-"
            }}</span>

          </template>
          <template slot="value_dpp" slot-scope="text, data">
            <div style="width:100%">
              <span style="float:center">{{
                formatCurrency("IDR", data.value_dpp)
              }} /</span><br />
              <span style="float:center">{{
                formatCurrency("IDR", data.value)
              }}</span>
            </div>
          </template>
          <template slot="document_tax" slot-scope="text, data">
            <div style="width:100%;text-align:center">
              {{ data.document_sts == "Document Not Complete" ? "Not Complete" : "Complete" }}
              <a-tooltip placement="bottomRight" title="View Document">
                <a-button icon="file" size="small" type="link" v-if="!(
                    data.document_tax &&
                    data.document_tax == 'No File Uploaded'
                  )
                  " @click="handleviewAttacment(data)"></a-button>
                <a-button v-else :disabled="true" size="small" type="link" icon="file"></a-button>
              </a-tooltip>
            </div>
          </template>
          <template slot="createby" slot-scope="text, data">
            <div style="text-align:center">
              {{ data.tlc_create }} /<br />
              {{ moment(data.date_create).format(getStandartFormatDate) }}
            </div>
          </template>
          <template slot="object_deposite" slot-scope="text, data">
            <span>{{
              data.kode_setoran_pajak ? data.kode_setoran_pajak : "-"
            }}
              /<br />
              {{
                data.kode_objek_pajak ? data.kode_objek_pajak : "-"
              }}</span>
          </template>
          <template slot="aksi" slot-scope="text, data">
            <!-- <a-checkbox
                :checked="data.check=='1' ? true : false"
                :disabled="action_label=='Set' || closetrans"
                @change="handledatachecked(data.id)"
              ></a-checkbox> -->
            <a-checkbox :disabled="data.sts_proses == '1' || data.isspt == '0' || data.discheck"
              :checked="data.check == '1' ? true : false"
              @change="handledatachecked(data.id_tax_transaction)"></a-checkbox>
          </template>
        </a-table>
      </a-config-provider>
    </a-col>

    <a-modal v-model="modalPbkTrans" v-if="modalPbkTrans" :footer="null" width="400px">
      <span slot="title">
        PBK Value # {{ formatRupiah(collectData.information.nilai_pbk) }}
      </span>
      <ul class="m-list-wrapper bordered">
        <li v-for="(data, index) in collectData.list_pbk" :key="index">
          <a-row :gutter="8">
            <a-col :xs="{ span: 24 }" :lg="{ span: 2 }">{{ index + 1 }}.</a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">{{ data.request_pbk_no }}</a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 10 }" style="text-align:right"><a
                @click="goToPBKManifest(data.request_pbk_id)">View Manifest</a></a-col>
          </a-row>
          <a-row :gutter="8">
            <a-col :xs="{ span: 24 }" :lg="{ span: 2 }"></a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 22 }"><b>{{ formatRupiah(data.value_req_pbk) }}</b></a-col>
          </a-row>
        </li>
      </ul>
    </a-modal>
  </a-row>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import GlobalMethod from "@/mixins/GlobalMethod";
import CheckboxAll from "@/components/CheckboxAllHeader.vue";
import HandleRoute from "@/mixins/HandleRoute";
import _ from "lodash";

export default {
  name: "Informasi",
  mixins: [CurrencyFormat, GlobalMethod, HandleRoute],
  components: { CheckboxAll },
  props: ["id", "collectData", "catatan", "catatanOri"],
  data() {
    const columns = {
      create:
        [{
          title: "#",
          key: "nomor",
          align: "center",
          scopedSlots: { customRender: "nomor" },
          width: 50,
        },
        {
          title: "No.Transaction",
          key: "notrans",
          scopedSlots: { customRender: "notrans" },
          width: 250,
        },
        {
          title: "Tax Type / Tax Date",
          key: "tax_type_date",
          align: "center",
          scopedSlots: { customRender: "tax_type_date" },
          width: 100,
        },
        {
          title: "DPP / Tax Value",
          key: "dpptax",
          align: "center",
          scopedSlots: { customRender: "dpptax" },
          width: 150,
        },
        {
          title: "Status Document",
          key: "document_tax",
          scopedSlots: { customRender: "document_tax" },
          width: 150,
        },]
      ,
      edit: [{
        title: "#",
        key: "nomor",
        scopedSlots: { customRender: "nomor" },
        width: 40,
        align: "center",
      },
      {
        title: "No / Type",
        key: "no",
        scopedSlots: { customRender: "no_trans" },
        width: 250,
      },
      {
        title: "Date / TLC",
        key: "date",
        align: "center",
        scopedSlots: { customRender: "trans_dt" },
        width: 100,
      },
      {
        title: "Invoice Date",
        key: "invoicedate",
        align: "center",
        scopedSlots: { customRender: "invoicedate" },
        width: 100,
      },
      {
        title: "Tax Type / Tax Date",
        key: "tax_date",
        align: "center",
        scopedSlots: { customRender: "tax_dt" },
        width: 150,
      },
      {
        title: "Description",
        key: "description",
        dataIndex: "description",
        width: 200,
      },
      {
        title: "DPP / Tax Value",
        key: "value_dpp",
        align: "center",
        scopedSlots: { customRender: "value_dpp" },
        width: 150,
      },
      {
        title: "Deposite Code / Tax Object",
        key: "object_deposite",
        align: "center",
        scopedSlots: { customRender: "object_deposite" },
        width: 200,
      },
      {
        title: "Create By",
        key: "createby",
        scopedSlots: { customRender: "createby" },
        width: 150,
      },
      {
        title: "Status Document",
        key: "document_tax",
        scopedSlots: { customRender: "document_tax" },
        width: 200,
      },
      {
        title: <CheckboxAll textlabel="Action" />,
        align: "center",
        fixed: "right",
        scopedSlots: { customRender: "aksi" },
        width: 90,
      },]
    };
    return {
      data_col_left: [],
      data_source: {
        trans: [],
        ori: [],
        ref: [],
      },
      columns,
      pagination: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 10,
        size: "small",
      },
      col: {
        left: 8,
        right: 16
      },
      position_status: "create",
      search: undefined,
      loading: {
        savedtl: false,
      },
      rectification_valOri: 0,
      note: "",
      modalPbkTrans: false,
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getAuth"
    ]),
    initialData() {
      if (this.collectData.information != null) {
        return this.collectData;
      } else {
        return this.$route.params ? this.$route.params : null;
      }
    },
  },
  created() {
    this.mountData();
  },
  mounted() {
    this.processMount();
  },
  activated() {
    this.processMount();
  },
  methods: {
    moment,
    mountData() {
      this.data_col_left = [
        {
          title: "SPT Type",
          description: this.initialData.information ? this.initialData.information.jenis_spt : "",
          value: null
        }, {
          title: "Month-Year",
          description: this.initialData.information ? this.initialData.information.bulan_thn : "",
          value: null
        }, {
          title: "PPN Keluaran Value (a)",
          description: this.initialData.information ? this.formatCurrency('IDR', this.initialData.information.nilai_ppn_keluaran) : "",
          value: null
        }, {
          title: "PPN Masukan Value (b)",
          description: this.initialData.information ? this.formatCurrency('IDR', this.initialData.information.nilai_ppn_masukan) : "",
          value: null
        }, {
          title: (this.initialData.information && this.initialData.information.nilai_pbk ? "Total (a-b-c)" : "Total (a-b)"),
          description: this.initialData.information ? this.formatRupiah(this.initialData.information.total) : "",
          value: this.initialData.information ? this.initialData.information.total : 0
        },
      ];

      if (this.initialData.information && this.initialData.information.jenis_spt.includes('PPh21')) {
        this.data_col_left = [
          {
            title: "SPT Type",
            description: this.initialData.information ? this.initialData.information.jenis_spt : "",
            value: null
          }, {
            title: "Month-Year",
            description: this.initialData.information ? this.initialData.information.bulan_thn : "",
            value: null
          }, {
            title: "PPh 21 Salary Value (a)",
            description: this.initialData.information ? this.formatCurrency('IDR', this.initialData.information.nilai_pph21_gaji) : "",
            value: null
          }, {
            title: "PPh 21 Commision Value (b)",
            description: this.initialData.information ? this.formatCurrency('IDR', this.initialData.information.nilai_pph21_komisi) : "",
            value: null
          }, {
            title: "PPh 21 Saverance Value (c)",
            description: this.initialData.information ? this.formatCurrency('IDR', this.initialData.information.nilai_pph21_pesangon) : "",
            value: null
          }, {
            title: (this.initialData.information && this.initialData.information.nilai_pbk ? 
              "Total PPh 21 (a+b+c-d)" : ("Total PPh 21 (a+b+c)")),
            description: this.initialData.information ? this.formatRupiah(this.initialData.information.total) : "",
            value: this.initialData.information.total ? this.initialData.information.total : 0
          },
        ];

        if(this.initialData.information.previous_spt_value!=0){
          this.data_col_left.splice(5,0,{
            title: "Total PPh 21 (a+b+c)",
            description: this.initialData.information ? this.formatCurrency('IDR', this.initialData.information.total) : "",
            value: null
          })
          this.data_col_left.splice(6,0,{
            title: "Previous SPT Value (d)",
            description: this.initialData.information ? this.formatCurrency('IDR', this.initialData.information.previous_spt_value) : "",
            value: null
          })
          this.data_col_left[this.data_col_left.length-1].title = 'Remaining SPT Value (a+b+c-d)'
          this.data_col_left[this.data_col_left.length-1].description = this.initialData.information.grandtotal ? this.formatCurrency('IDR', this.initialData.information.grandtotal) : ""
          this.data_col_left[this.data_col_left.length-1].value = this.initialData.information.grandtotal ? this.initialData.information.grandtotal : 0
        }
      } else if (this.initialData.information && this.initialData.information.jenis_spt.includes('SPT Unifikasi')) {
        this.data_col_left = [
          {
            title: "SPT Type",
            description: this.initialData.information ? this.initialData.information.jenis_spt : "",
            value: null
          }, {
            title: "Month-Year",
            description: this.initialData.information ? this.initialData.information.bulan_thn : "",
            value: null
          }, {
            title: "PPh 4 (ayat 2) Value (a)",
            description: this.initialData.information ? this.formatCurrency('IDR', this.initialData.information.nilai_pph_pasal4) : "",
            value: null
          }, {
            title: "PPh 22 Value (b)",
            description: this.initialData.information ? this.formatCurrency('IDR', this.initialData.information.nilai_pph22) : "",
            value: null
          }, {
            title: "PPh 23 Value (c)",
            description: this.initialData.information ? this.formatCurrency('IDR', this.initialData.information.nilai_pph23) : "",
            value: null
          }, {
            title: (this.initialData.information && this.initialData.information.nilai_pbk ? "Total Unifikasi Value (a+b+c-d)" : "Total Unifikasi Value (a+b+c)"),
            description: this.initialData.information ? this.formatRupiah(this.initialData.information.total) : "",
            value: this.initialData.information.total ? this.initialData.information.total : 0
          },
        ];

        if(this.initialData.information.previous_spt_value!=0){
          this.data_col_left.splice(5,0,{
            title: "Total PPh 21 (a+b+c)",
            description: this.initialData.information ? this.formatCurrency('IDR', this.initialData.information.total) : "",
            value: null
          })
          this.data_col_left.splice(6,0,{
            title: "Previous SPT Value (d)",
            description: this.initialData.information ? this.formatCurrency('IDR', this.initialData.information.previous_spt_value) : "",
            value: null
          })
          this.data_col_left[this.data_col_left.length-1].title = 'Remaining SPT Value (a+b+c-d)'
          this.data_col_left[this.data_col_left.length-1].description = this.initialData.information.grandtotal ? this.formatCurrency('IDR', this.initialData.information.grandtotal) : ""
          this.data_col_left[this.data_col_left.length-1].value = this.initialData.information.grandtotal ? this.initialData.information.grandtotal : 0
        }
      }

      if (this.initialData.information && this.initialData.information.nilai_pbk) {
        this.data_col_left.splice(this.data_col_left.length - 1, 0,
          {
            title: (this.initialData.information && (this.initialData.information.jenis_spt.includes('SPT Unifikasi') || this.initialData.information.jenis_spt.includes('PPh21') ? "PBK Value (d)" : "PBK Value (c)")),
            description: this.formatRupiah(this.initialData.information.nilai_pbk),
            value: null
          }
        )
      }

      this.rectification_valOri = this.tipe ? this.initialData.information.total : 0;
      //let text = this.data_col_left[this.data_col_left.length - 1].value < 0 ? 'overpayment' : 'insufficient payment';
      //Event.$emit("triggerNext", { text: text });
    },
    handleToEdit() {
      if (this.col.left == 8) {
        this.position_status = "edit";
        this.col.left = 0;
        this.col.right = 24;
        Event.$emit("disableNext", true);
        Event.$emit("triggerdisbutton", true);
      } else {
        this.position_status = "create";
        this.col.left = 8;
        this.col.right = 16;
        Event.$emit("disableNext", false);
        Event.$emit("triggerdisbutton", false);
      }

      this.search = undefined;
      this.searching({ target: { value: undefined } });
      this.cleartabelcheck();
      this.data_source.trans.forEach((item, index) => {
        let ind = _.findIndex(this.data_source.ori, (e) => {
          return e.id_tax_transaction == item.id_tax_transaction;
        }, 0);
        if (ind >= 0)
          this.data_source.ori[ind].check = "1";
      });
    },
    handleRef() {
      // let flags = true;
      // let ttl = 0;
      // this.data_source.trans.forEach((element) => {
      //   if (this.initialData.information.jenis_spt.includes('PPN') && element.type.includes('account_receivable')) {
      //     ttl = ttl + Number(element.value)
      //   } else if (this.initialData.information.jenis_spt.includes('PPN') && !element.type.includes('account_receivable')) {
      //     ttl = ttl - Number(element.value)
      //   } else {
      //     ttl = ttl + Number(element.value)
      //   }
      // });
      // console.log(this.tipe,this.rectification_valOri, ttl)
      // if (this.tipe && this.rectification_valOri == ttl) {
      //   flags = false;
      //   this.displayMessageValue("error-other", "Please Edit List tax Details Now...!");
      // }

      // if (flags) {
      Event.$emit("sptData", {
        from: "next",
        information: this.collectData.information == null ? this.initialData.information : this.collectData.information,
        list_tax_detail: this.collectData.list_tax_detail == null ? this.initialData.list_tax_detail : this.collectData.list_tax_detail,
        extra: {
          note: (this.collectData.information.total < 0 ? this.catatan : this.catatanOri),
          is_draft: '1'
        }
      });
      // }
    },
    handleRefDraft() {
      Event.$emit("sptData", {
        from: "submit",
        information: this.collectData.information == null ? this.initialData.information : this.collectData.information,
        list_tax_detail: this.collectData.list_tax_detail == null ? this.initialData.list_tax_detail : this.collectData.list_tax_detail,
        extra: {
          note: this.note,
          is_draft: '1'
        }
      });
    },
    handleRefSubmit() {
      Event.$emit("sptData", {
        from: "submit",
        information: this.collectData.information == null ? this.initialData.information : this.collectData.information,
        list_tax_detail: this.collectData.list_tax_detail == null ? this.initialData.list_tax_detail : this.collectData.list_tax_detail,
        extra: {
          note: this.note,
          is_draft: '0'
        },
        status_besar: this.collectData.status_besar,
      });
    },
    handleviewAttacment(item) {
      window.open(this.$serviceUrl + item.document_path);
    },
    searching(val) {
      val = val.target.value;
      this.data_source.ori = [];
      if (val) {
        this.data_source.ori = _.filter(this.data_source.ref, (item) =>
          item.no_trans.toLowerCase().indexOf(val.toLowerCase()) >= 0 ||
          item.tax_type_label.toLowerCase().indexOf(val.toLowerCase()) >= 0 ||
          item.tlc_create.toLowerCase().indexOf(val.toLowerCase()) >= 0 ||
          item.type_label.toLowerCase().indexOf(val.toLowerCase()) >= 0 ||
          (item.description && item.description.toLowerCase().indexOf(val.toLowerCase()) >= 0) ||
          item.document_sts && item.document_sts.toLowerCase().indexOf(val.toLowerCase()) >= 0
        );
      } else {
        this.data_source.ori = this.data_source.ref;
      }
    },
    handledatachecked(val) {
      let ind = _.findIndex(this.data_source.ref, (e) => {
        return e.id_tax_transaction == val;
      }, 0);
      this.data_source.ref[ind].check = (this.data_source.ref[ind].check === "1" ? "0" : "1");

      // let ind2 = _.findIndex(this.data_source.ori, (e) => {
      //   return e.id_tax_transaction == val;
      // }, 0);
      // this.data_source.ori[ind2].check = (this.data_source.ori[ind2].check === "1" ? "0" : "1");

      this.searching({ target: { value: this.search } });
    },
    handlelinkNo(item) {
      item.rest_api = item.type.toLowerCase();
      item.id_manifest = item.id_transaction;
      item.user_pembuat = item.tlc;
      item.tab = "release";
      item.jns = "Penerimaan_Kontrak";
      item.jenis = "Penerimaan_Kontrak";
      this.handleView(item, true);
    },
    handlelinkTaxVerivication(item) {
      this.modalTaxVerification = true;
      this.modalTax.loading = true;
      this.asyncAxiosGet("tax_verification", this.getAuth, {
        id_transaksi: item.id_transaction,
        jenis_transaksi: item.type
      })
        .then((res) => {
          //     this.modalData.costcenterOri = res.cost_center;
          // this.modalData.id_header = res.id_header;
          this.modalTax.source = res.list_tax_dtl;
          this.modalTax.jenis_transaksi_label = res.jenis_transaksi_lbl;
          this.modalTax.no_transaction = res.no_transaction;
          // for (let w = 0; w < this.modalData.detil_transaction.length; w++) {
          //   this.modalData.detil_transaction[w].disabled = false;
          // }
          //this.modalData.listsetoranpajak = res.setoran;
          // this.modalData.listsetoranpajakOri = res.setoran;
          // this.modalData.listobjekpajak = res.objek;
          // if (res.list_tax_dtl) {
          //   this.verificationdtl_source = res.list_tax_dtl;
          //   for (let x = 0; x < this.verificationdtl_source.length; x++) {
          //     if (this.verificationdtl_source[x].id == undefined)
          //       this.verificationdtl_source[x].id = this.verificationdtl_source[x].id_dtl;
          //   }
          // }
          // this.dtlmodalchange();

          // this.loading.create = false;
          // this.modalProcess = !this.modalProcess;
          // this.loading.modalProcess = false;

          this.modalTax.loading = false;
        })
        .catch((err) => {
          this.modalTax.loading = false;
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
        });
    },
    handleToSave() {
      this.loading.savedtl = true;
      let selected_item = [];

      this.search = undefined;
      this.searching({ target: { value: null } });

      let existnotcompletechecked = _.filter(this.data_source.ori, (item) =>
        item.document_sts == "Document Not Complete" && item.check == '1'
      );

      if (existnotcompletechecked.length > 0) {
        this.displayMessageValue("error-other", "Status Document is Not Complete can't be checked, please correct it's!");
        this.loading.savedtl = false;
        return;
      }

      this.data_source.ori.forEach((item) => {
        if (item.check == "1") {
          selected_item.push({
            id_tax_transaction: item.id_tax_transaction,
          });
        }
      });
      let data = new FormData();
      data.append("spt_id", this.initialData.information.spt_id);
      data.append("selected_item", JSON.stringify(selected_item));

      this.asyncAxiosPost("spt/edit_dtl_spt", "formdata", this.getAuth, data)
        .then((response) => {
          this.axiosGet("spt/edit_dtl_spt", this.getAuth, {
            spt_id: this.initialData.information.spt_id,
          })
            .then((res2) => {
              let tempsource = res2.data;
              for (let w = 0; w < tempsource.length; w++) {
                tempsource[w]['check'] = null;
              }

              let informations = response.information
              // if (response.information.nilai_pbk) {
              //   informations.total = response.information.total- response.information.nilai_pbk
              // }

              Event.$emit("sptData", {
                from: "axios",
                information: informations,
                list_tax_detail: response.list_tax_detail,
                source: tempsource,
                status_besar: this.position_status == 'create' ? "" : this.collectData.status_besar,
                total_nilai_label: response.information.total < 0 ? 'Lebih Bayar' : 'Kurang Bayar',
                extra: {
                  note: this.note ? this.note : this.catatan,
                  is_draft: '0'
                }
              });
              this.handleToEdit();
              this.mountData();
              this.data_source.trans = this.initialData.list_tax_detail ? this.initialData.list_tax_detail : [];
              this.loading.savedtl = false;
              Event.$emit("triggerdisbutton", false);
            })
            .catch((err) => {
              Event.$emit("pgloading", false);
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error-other", responses.message);
              this.$router.go(-1);
            });
        })
        .catch((err) => {
          console.log(err);
          this.loading.savedtl = false;
          let responses = Object.assign({}, err.response.data);
          this.displayMessageValue("error-other", responses.message);
          this.loading.createtaxmanual = false;
        });
    },
    cleartabelcheck() {
      this.data_source.ref.forEach((item, index) => {
        this.data_source.ref[index].check = "0";
      });
      this.data_source.ori.forEach((item, index) => {
        this.data_source.ori[index].check = "0";
      });
    },
    processMount() {
      if (this.id) {
        Event.$emit("pgloading", true);
        // if (this.id && this.tipe) {
        //   this.asyncAxiosPost("spt/pembetulan", "application/json", this.getAuth, {spt_id:this.id})
        //   .then((res) => {
        //       this.axiosGet("spt/edit_dtl_spt", this.getAuth, {
        //         spt_id: this.id,
        //       })
        //         .then((res2) => {
        //           let templist_tax_detail = res.list_tax_detail;
        //           for (let w = 0; w < templist_tax_detail.length; w++) {
        //             templist_tax_detail[w]['check'] = null;
        //           }

        //           let tempsource = res2.data;
        //           for (let w = 0; w < tempsource.length; w++) {
        //             tempsource[w]['check'] = null;
        //           }

        //           Event.$emit("sptData", {
        //             from: "axios",
        //             information: res.information,
        //             list_tax_detail: templist_tax_detail,
        //             source: tempsource
        //           });
        //           this.mountData();
        //           this.data_source.trans = this.initialData.list_tax_detail ? this.initialData.list_tax_detail : [];
        //           this.data_source.ori = this.initialData.source ? this.initialData.source : [];
        //           this.data_source.ref = this.data_source.ori;
        //           // for (let w = 0; w < this.data_source.ori.length; w++) {
        //           //   this.data_source.ori[w]['check'] = null;
        //           // }
        //           // this.data_source.ref = this.initialData.source ? this.initialData.source : [];
        //           // for (let w = 0; w < this.data_source.ref.length; w++) {
        //           //   this.data_source.ref[w]['check'] = null;
        //           // }
        //           Event.$emit("pgloading", false);
        //         })
        //         .catch((err) => {
        //           Event.$emit("pgloading", false);
        //           let responses = Object.assign({}, err.response.data);
        //           this.displayMessageValue("error-other", responses.message);
        //           this.$router.go(-1);
        //         });
        //     })
        //   .catch((err) => {
        //     Event.$emit("pgloading", false);
        //     this.$router.push({
        //       name: "SPTManifest",
        //       params: { id: this.id },
        //     });
        //     let responses = Object.assign({}, err.response.data);
        //     this.displayMessageValue("error-other", responses.message);
        //   });
        // } else {
        this.axiosGet("spt", this.getAuth, {
          spt_id: this.id,
        })
          .then((res) => {
            this.axiosGet("spt/edit_dtl_spt", this.getAuth, {
              spt_id: this.id,
            })
              .then((res2) => {
                let templist_tax_detail = res.list_tax_detail;
                for (let w = 0; w < templist_tax_detail.length; w++) {
                  templist_tax_detail[w]['check'] = null;
                }

                let tempsource = res2.data;
                for (let w = 0; w < tempsource.length; w++) {
                  tempsource[w]['check'] = null;
                }
                this.note = (this.note == '' ? res.note : this.note);

                let inf = res.information
                res.information.total = res.total

                if(res.information.jenis_spt_value=="pph_21" || res.information.jenis_spt_value=="pph_unifikasi"){
                  let a = inf.total-Number(inf.previous_spt_value)
                  res.total_nilai_label = a < 0 ? 'Lebih Bayar' : 'Kurang Bayar'
                  inf['grandtotal'] = inf.total-inf.previous_spt_value
                }

                Event.$emit("sptData", {
                  from: "axios",
                  information: inf,
                  list_tax_detail: templist_tax_detail,
                  source: tempsource,
                  pembetulan: {
                    tipe_pembetulan: res.tipe_pembetulan,
                    tipe_pembetulan_label: res.tipe_pembetulan_label
                  },
                  extra: {
                    note: res.note,
                    is_draft: '1'
                  },
                  status_besar: res.status_besar,
                  total_nilai_label: res.total_nilai_label,
                  noteOri: res.note,
                  list_pbk: res.list_pbk ? res.list_pbk : [],
                });
                this.mountData();
                this.data_source.trans = this.initialData.list_tax_detail ? this.initialData.list_tax_detail : [];
                this.data_source.ori = this.initialData.source ? this.initialData.source : [];
                this.data_source.ref = this.data_source.ori;
                // for (let w = 0; w < this.data_source.ori.length; w++) {
                //   this.data_source.ori[w]['check'] = null;
                // }
                // this.data_source.ref = this.initialData.source ? this.initialData.source : [];
                // for (let w = 0; w < this.data_source.ref.length; w++) {
                //   this.data_source.ref[w]['check'] = null;
                // }
                Event.$emit("pgloading", false);
              })
              .catch((err) => {
                Event.$emit("pgloading", false);
                let responses = Object.assign({}, err.response.data);
                this.displayMessageValue("error-other", responses.message);
                this.$router.go(-1);
              });
          })
          .catch((err) => {
            Event.$emit("pgloading", false);
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
            this.$router.go(-1);
          });
        // }
      } else {
        this.mountData();
        this.data_source.trans = this.initialData.list_tax_detail ? this.initialData.list_tax_detail : [];
        this.data_source.ori = this.initialData.source ? this.initialData.source : [];
        this.data_source.ref = this.initialData.source ? this.initialData.source : [];
        Event.$emit("pgloading", false);
      }

      if (this.catatan) {
        this.note = this.catatan;
      }
    },
    viewtransPBK() {
      this.modalPbkTrans = true
    },
    goToPBKManifest(id) {
      const route = this.$router.resolve({
        name: "pbkManifest",
        params: { id: id },
      });
      window.open(route.href, "_blank");
    }
  },
  watch: {
    data_col_left() {
      if (this.data_col_left.length > 0) {
        //let text = this.data_col_left[this.data_col_left.length - 1].value < 0 ? 'overpayment' : 'insufficient payment';
        //Event.$emit("triggerNext", { text: text });
      }
    }
  }
};
</script>

<style lang="less">
.bg_red {
  background: fade(red, 20%);
}

.bg_green {
  background: fade(green, 20%);
}

.bg_yellow {
  background: fade(yellow, 20%);
}
</style>